import type { CareerStep, EmployeeGrowth } from '@/types/career-growth';
import type { LocalizedText } from '@/utils/localization';

import { getLocalizedText } from '@/utils/localization';

/**
 * The `Target` step of the employee's career path, `null` without one. It is set from the steps
 * editor alone: the position an aspiration says the employee wants is a separate fact and is never
 * copied here. The "Prochaine cible" card and the skills to develop read this step.
 */
export const readTargetStep = (
    growth: Pick<EmployeeGrowth, 'careerSteps'> | undefined,
): CareerStep | null => growth?.careerSteps.find((step) => step.kind === 'Target') ?? null;

/**
 * The name a position goes by: its title, or the competency profile it requires when a target is
 * named by that profile alone. `null` when it has neither.
 */
export const readPositionName = (position: {
    title: string | null;
    competencyProfileName: LocalizedText | null;
}): string | null =>
    position.title?.trim() || getLocalizedText(position.competencyProfileName ?? undefined) || null;

/** The name of the target step, `null` without one. */
export const readTargetStepTitle = (
    growth: Pick<EmployeeGrowth, 'careerSteps'> | undefined,
): string | null => {
    const targetStep = readTargetStep(growth);
    return targetStep && readPositionName(targetStep);
};
